// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.VerifyLandlordIdentityExtendedWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  VerifyLandlordIdentityExtendedWebApiRequestDto,
  VerifyLandlordIdentityExtendedWebApiResponseDto,
} from '../..';

export const VerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended_Path =
  '/api/web/v1/verifyLandlordIdentityExtended';

/**
 * Verify landlord identity extended
 */
export const VerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended = (
  postData: VerifyLandlordIdentityExtendedWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    VerifyLandlordIdentityExtendedWebApiRequestDto,
    VerifyLandlordIdentityExtendedWebApiResponseDto
  >(
    {
      endpoint: VerifyLandlordIdentityExtendedWebApiHandler_verifyLandlordIdentityExtended_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
